import Vue from 'vue'
import Router from 'vue-router'
import Top from '@/components/home/Top'
import Home from '@/components/home/Home'
import Signup from '@/components/auth/Signup'
import Login from '@/components/auth/Login'
import ViewProfile from '@/components/profile/ViewProfile'
import AddContent from '@/components/contents/AddContent'
import Content from '@/components/contents/Content'
import About from '@/components/info/About'
import UsePolicy from '@/components/info/UsePolicy'
import Info from '@/components/info/Info'
import Faq from '@/components/info/Faq'
import firebase from 'firebase'
import SearchContent from '@/components/contents/SearchContent'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top,
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/usepolicy',
      name: 'UsePolicy',
      component: UsePolicy
    },
    {
      path: '/info',
      name: 'Info',
      component: Info
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/profile/:id',
      name: 'ViewProfile',
      component: ViewProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/add-content',
      name: 'AddContent',
      component: AddContent,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/content/:slug',
      name: 'Content',
      component: Content,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/search-content',
      name: 'SearchContent',
      component: SearchContent,
      meta: {
        requiresAuth: true
      }
    }


  ]
})

// router guards
router.beforeEach((to, from, next) => {
  // check to see if route has auth guard
  if(to.matched.some(rec => rec.meta.requiresAuth)){
    // check auth state of user
    let user = firebase.auth().currentUser
    if (user) {
      // User is signed in. Proceed to route
      next()
    } else {
      // No user is signed in. Redirect to login
      next({
        name: 'Top'
      })
    }
  } else {
    // if route is not guarded by auth, proceed
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js